//import React from 'react';
import {useState} from 'react'
import Sidebar from './Sidebar';
import { useAuth } from '../context/AuthContext';
import { Link, useLocation } from 'react-router-dom';
import { ROLES } from '../utils/roles';

import './Layout.css';

const Layout = ({ children }) => {
  const { user, logout } = useAuth(); // Hent bruger fra context
  const [sidebarChoice, setSidebarChoice] = useState('censorAdm')
  const location = useLocation(); // Hent nuværende sti 
  const activeIndex = sidebarChoice === 'censorAdm' ? 0 : sidebarChoice === 'studentAdm' ? 1 : 2;

  console.log(`sdibare er [${sidebarChoice}]`)

  // Hjælper til initialer
  const getInitials = () => {
    if (!user) return '';
    const f = user.firstName ? user.firstName[0] : '';
    const l = user.lastName ? user.lastName[0] : '';
    return (f + l).toUpperCase();
  };

  // 1. DEFINER TITLER HER
  // Vi mapper URL-stien til den tekst, vi vil vise
  const getPageTitle = (pathname) => {
    // Fjern evt. trailing slash
    const path = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

    switch (path) {
      case '/dashboard': return 'Dashboard';
      case '/profile': return 'Min Profil';
      case '/staff': return 'Undervisere & Censorer';
      case '/contacts': return 'Kontaktpersoner';
      case '/classes': return 'Indberet prøvedeltagere';
      case '/organisations': return 'Organisationer';
      case '/language-centers': return 'Sprogcentre';
      case '/allocation/outgoing': return 'Censorfordeling: Egne';
      case '/allocation/incoming': return 'Censorfordeling: Udefra';
      case '/my-exams': return 'Mine Opgaver';
      case '/my-censor-data': return 'Mine Stamdata';
      case '/my-appointment': return 'Min Beskikkelse';
      case '/users': return 'Brugeradministration';
      // Default fallback
      default: return 'Sprogcenter Administration';
    }
  };
//  {user?.role === ROLES.SC_ADMIN  && 
  return (
    <div className="app-container">
      <Sidebar sidebarChoice={sidebarChoice} />
      <div className="main-area">        
        <header className="top-header">
          <div className="header-title">{getPageTitle(location.pathname)}</div>

       {user?.role === ROLES.SC_ADMIN  && 
          <div
            className={`top-switcher active-${activeIndex}`}
            style={{ '--active-index': activeIndex }}
            role="tablist"
            aria-label="Administrationssektion"
          >
            <button
              className={sidebarChoice === 'censorAdm' ? 'is-active' : ''}
              onClick={() => { setSidebarChoice('censorAdm'); }}
              aria-pressed={sidebarChoice === 'censorAdm'}
            >
              Censoradministration
            </button>
            <button
              className={sidebarChoice === 'studentAdm' ? 'is-active' : ''}
              onClick={() => { setSidebarChoice('studentAdm'); }}
              aria-pressed={sidebarChoice === 'studentAdm'}
            >
              Kursister & hold
            </button>
            <button
              className={sidebarChoice === 'examAdm' ? 'is-active' : ''}
              onClick={() => { setSidebarChoice('examAdm'); }}
              aria-pressed={sidebarChoice === 'examAdm'}
            >
              Prøveadministration
            </button>
          </div>
        }      
          {/* Højre side */}
          <div className="header-user-section">
            
            {/* 1. Profil Billede */}
            <div className="header-avatar">
              {user?.profilePicture ? (
                <img src={user.profilePicture} alt="Profil" />
              ) : (
                <span>{getInitials()}</span>
              )}
            </div>

            {/* 2. Navn (Kun fornavn + efternavn) */}
            <span className="header-name">
              {user?.firstName} {user?.lastName}
            </span>

            {/* 3. Tandhjul (Link til profil) */}
            <Link to="/profile" className="icon-btn" title="Profil Indstillinger">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
              </svg>
            </Link>

            {/* 4. Log ud */}
            <button onClick={logout} className="logout-btn">
              Log ud
            </button>

          </div>
        </header>
        
        <main className="content-wrapper">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;